/** A4 preview/PDF layout (~72dpi CSS pixels). Margins ~0.5in like standard resume templates. */

export const ATS_CV_PAGE_WIDTH = 595;
export const ATS_CV_PAGE_MIN_HEIGHT = 842;

/** Horizontal margin (~36px ≈ 0.5 inch) */
export const ATS_CV_MARGIN_X = 36;
export const ATS_CV_MARGIN_TOP = 36;
export const ATS_CV_MARGIN_BOTTOM = 48;

export const ATS_CV_CONTENT_WIDTH = ATS_CV_PAGE_WIDTH - ATS_CV_MARGIN_X * 2;

export const ATS_CV_PAGE_PADDING = `${ATS_CV_MARGIN_TOP}px ${ATS_CV_MARGIN_X}px ${ATS_CV_MARGIN_BOTTOM}px`;

/** The two-column "sidebar" template: a coloured rail on the left of every page. */
export const ATS_CV_SIDEBAR_WIDTH = 190;
/** Where the main column starts: the rail plus a gutter. */
export const ATS_CV_SIDEBAR_PAD_LEFT = ATS_CV_SIDEBAR_WIDTH + 24;

/** Left padding of the main column per two-column template: the rail plus its gutter. */
export const ATS_CV_RAIL_PAD_LEFT = {
    sidebar: ATS_CV_SIDEBAR_PAD_LEFT,
    split: ATS_CV_SIDEBAR_PAD_LEFT,
    bold: 246,
};
